import { jsx } from 'react/jsx-runtime';
import { useAssistant } from '@grafana/assistant';
import { Button } from '@grafana/ui';

"use strict";
function AnalyzeFlameGraphButton(props) {
  const { assistantContext, className } = props;
  const [isAvailable, openAssistant] = useAssistant();
  if (!isAvailable || !openAssistant || assistantContext.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      className,
      onClick: () => openAssistant({
        origin: "analyze-flame-graph",
        prompt: "Analyze Flame Graph",
        context: assistantContext
      }),
      variant: "secondary",
      fill: "outline",
      icon: "ai-sparkle",
      size: "sm",
      children: "Analyze Flame Graph"
    }
  );
}

export { AnalyzeFlameGraphButton };
//# sourceMappingURL=AnalyzeFlameGraphButton.mjs.map
